import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { MatchManager } from "../MatchManager";
import { Streaker } from "./pegs/Streaker";

    export class StreakerManager {

        private streakerShown: boolean;
        private game: Phaser.Game;
        private pegsContainer: Phaser.Group;
        private frequency: number;

        constructor(game: Phaser.Game, pegsContainer: Phaser.Group) {

            this.game = game;
            this.pegsContainer = pegsContainer;
            this.streakerShown = false;

            this.frequency = GameVars.streakerFrequency;
        }

        public onKickOffManagerReadyToShoot(): void {

            if ( this.streakerShown || this.frequency === 0) {
                return;
            }

            // el streaker sale en el penutimo lanzamiento con la frecuencia predeterminada
            // siempre que hagan falta mas de 2 goles para poder ganar el partido
            if ( GameVars.balls === 2 && GameVars.playerGoals >= 0 ) {

                // mirar la frecuencia con la que deberia salir
                if (Math.random() < 1 / this.frequency) {

                    // informar al modelo
                    MatchManager.onStreakerEntry();

                    this.game.time.events.add(1500, function(): void {
                        this.addStreaker();
                    }, this);
                }
            }
        }

        private addStreaker(): void {

            this.streakerShown = true;

            let r = Math.random();
            let direction = r > 0.5 ? true : false;

            let px = direction ? 900 : -125;

            let height: number;
            r = Math.random();

            if ( r > .7) {
                height = 150;
            } else if ( r > .3) {
                height = 350;
            } else {
                height = 550;
            }

            // ya que se sabe la direccion mandarle de paso la posicion en x y en y
            const streaker = new Streaker( this.game, px, height, direction);
            
            this.pegsContainer.add(streaker);
            this.pegsContainer.bringToTop(streaker);
        }
    }
